import AxiosService from "@/Services/AxiosService";
import { Inject, Service } from "vue-di-container";
@Service()
export default class RequestsService {
  @Inject(AxiosService) public axiosService!: AxiosService;

  public async GetDefaultDates(): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-default-dates";
      const result = await this.axiosService.axiosInstance.get(url);
      return result.data.result;
    } catch (exception) {
      return false;
    }
  }

  public async GetTenants(): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-tenants";
      const result = await this.axiosService.axiosInstance.get(url);
      return result.data.result;
    } catch (exception) {
      return false;
    }
  }

  public async GetMonitorDashboardOptions(): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-monitor-dashboard-options";
      const result = await this.axiosService.axiosInstance.post(url, {});
      return result.data.result;
    } catch (exception) {
      return false;
    }
  }

}
